import React, { useCallback, useState } from 'react';
import { Text, Tag, Label, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';

const tooltipFill ='#4f4d54';

const PADDING = 30;

export default function AutomationTooltip({value, x, y, height, selectedParameter}) {
    if (selectedParameter.toFrequency) {
        value = selectedParameter.quantize(value).toNotation();
    } else if (selectedParameter.getOptionFromNumber) {
        value = selectedParameter.getOptionFromNumber(value);
    } else {
        value = Math.round(value*1000) / 1000;
    }
    let dist = y < PADDING ? -5 : -20;
    let pointerDist = y < PADDING ? 10  : -5;
    let textX = x;
    let textY = y < PADDING ? y + 20 : y - 20;
    let points = [x, y + pointerDist, textX - 5, textY, textX + 5, textY ];
    return [
        (<rect x={x - 20} y={textY + dist} width={50} height={20} fill={tooltipFill}/>),
        (<polygon points={points} fill={tooltipFill}/>),
        (<text
          fill="white"
          x={x - 15} y={textY + pointerDist} className="automation-tooltip">
          {value.toString()}
        </text>
    )
    ];
}

